<template>
  <div class="bg-white rounded-lg shadow-sm border border-gray-200">
    <div class="p-4 border-b border-gray-200 flex items-center space-x-3">
      <span class="material-symbols-outlined text-xl text-primary">settings</span>
      <h2 class="text-lg font-semibold text-gray-800">Account Actions</h2>
    </div>
    <div class="p-4 sm:p-6">
      <div class="space-y-4">
        <!-- Log Out Action -->
        <button 
          @click="$emit('logout')" 
          :disabled="loading" 
          class="group w-full flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100/50 rounded-xl hover:from-primary-lighter hover:to-primary-light transition-all duration-200 border border-gray-200 hover:border-primary/30 hover:shadow-md"
        >
          <div class="flex items-center space-x-4">
            <div class="w-12 h-12 bg-white rounded-xl flex items-center justify-center group-hover:bg-primary-lighter transition-all shadow-sm group-hover:shadow-md group-hover:scale-105">
              <span class="material-symbols-outlined text-primary text-xl">logout</span>
            </div>
            <div class="text-left">
              <span class="block font-semibold text-gray-900 group-hover:text-primary transition-colors">Log Out</span>
              <span class="block text-sm text-gray-500 group-hover:text-primary/70 transition-colors">Sign out of your account</span>
            </div>
          </div>
          <span class="material-symbols-outlined text-gray-400 group-hover:text-primary transition-colors transform group-hover:translate-x-1">chevron_right</span>
        </button>

        <!-- Change Password Action -->
        <router-link 
          to="/change-password"
          class="group w-full flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100/50 rounded-xl hover:from-primary-lighter hover:to-primary-light transition-all duration-200 border border-gray-200 hover:border-primary/30 hover:shadow-md"
        >
          <div class="flex items-center space-x-4">
            <div class="w-12 h-12 bg-white rounded-xl flex items-center justify-center group-hover:bg-primary-lighter transition-all shadow-sm group-hover:shadow-md group-hover:scale-105">
              <span class="material-symbols-outlined text-primary text-xl">lock</span>
            </div>
            <div class="text-left">
              <span class="block font-semibold text-gray-900 group-hover:text-primary transition-colors">Change Password</span>
              <span class="block text-sm text-gray-500 group-hover:text-primary/70 transition-colors">Update your password for security</span>
            </div>
          </div>
          <span class="material-symbols-outlined text-gray-400 group-hover:text-primary transition-colors transform group-hover:translate-x-1">chevron_right</span>
        </router-link>

        <!-- Delete Account Action -->
        <button 
          @click="$router.push('/delete-account')"
          class="group w-full flex items-center justify-between p-4 bg-gradient-to-r from-red-50 to-red-100/50 rounded-xl hover:from-red-100 hover:to-red-200/50 transition-all duration-200 border border-red-200 hover:border-red-300 hover:shadow-md"
        >
          <div class="flex items-center space-x-4">
            <div class="w-12 h-12 bg-white rounded-xl flex items-center justify-center group-hover:bg-red-50 transition-all shadow-sm group-hover:shadow-md group-hover:scale-105">
              <span class="material-symbols-outlined text-red-600 text-xl">delete</span>
            </div>
            <div class="text-left">
              <span class="block font-semibold text-red-700 group-hover:text-red-800 transition-colors">Delete Account</span>
              <span class="block text-sm text-red-500 group-hover:text-red-600 transition-colors">Permanently remove your account</span>
            </div>
          </div>
          <span class="material-symbols-outlined text-red-400 group-hover:text-red-600 transition-colors transform group-hover:translate-x-1">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountActionsCard',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['logout']
};
</script>

<style scoped>
/* Enhanced gradients and animations */
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

/* Enhanced hover effects */
@media (hover: hover) {
  .group:hover .transform {
    transform: translateX(0.25rem);
  }
  
  .group:hover .group-hover\:scale-105 {
    transform: scale(1.05);
  }
}

/* Enhanced shadows */
.shadow-sm {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.hover\:shadow-md:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .space-y-4 > * + * {
    margin-top: 1rem;
  }
  
  .space-x-4 > * + * {
    margin-left: 1rem;
  }
}

/* Focus states */
button:focus,
a:focus {
  outline: 2px solid rgba(66, 153, 225, 0.5);
  outline-offset: 2px;
}
</style>
